<template>
    <b-list-group-item
        class="lista-menu"
        v-if="$temAcessoView('SGTEC-REL-00')"
        @click.stop="abrirModal()"
        ><span>RELATÓRIO DE FATURAMENTO DE ETAPAS</span>
        <filtro
            ref="filtroModal"
            :servicos="obterFaturamentoServicos()"
            @filtrar="obterRelatorio($event)"
        ></filtro>
    </b-list-group-item>
</template>

<script>
import download from '../../../../shared/download'
import filtro from './RelatorioFaturamentoEtapasFiltro'
import FaturamentoServicos from './FaturamentoServicos'

export default {
    components: {
        filtro
    },

    methods: {
        abrirModal() {
            this.$refs.filtroModal.abrir()
        },

        obterRelatorio(filtro) {
            this.$store.dispatch('addRequest')
            FaturamentoServicos.obterRelatorioFaturamentoEtapas(filtro).then((response) => {
                if (response) {
                    if (response.type === 'application/json') {
                        this.$toast.error(
                            'Falha ao obter relatório',
                            'ERROR',
                            this.$toastConfig.error
                        )
                    } else {
                        download(response, `Relatorio_Faturamento_Etapas.xlsx`)
                    }
                }
                this.$store.dispatch('removeRequest')
            })
        },

        obterFaturamentoServicos() {
            return FaturamentoServicos
        }
    }
}
</script>